if (!customElements.get('autoplay-section')) {
  class AutoplaySection extends HTMLElement {
    static ACTIVE_CLASS = 'is-active';
    static THRESHOLD = 0.25;

    constructor() {
      super();
    }

    connectedCallback() {
      const section = this.querySelector('.js-hover-video');

      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            const toggleClass = (video) => {
              entry.target.classList.toggle(
                AutoplaySection.ACTIVE_CLASS,
                entry.isIntersecting &&
                  entry.intersectionRatio >= AutoplaySection.THRESHOLD,
              );
            };

            const video = section.querySelector('video');
            if (!video) return;

            if (video.readyState >= 3) {
              toggleClass(video);
            } else {
              video.addEventListener('canplay', () => {
                toggleClass(video);
              });
            }
          });
        },
        { threshold: [AutoplaySection.THRESHOLD] },
      );

      observer.observe(section);
    }
  }

  customElements.define('autoplay-section', AutoplaySection);
}
